/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'

const SigninLazyRouteImport = createFileRoute('/signin')()
const AuthenticatedIndexLazyRouteImport = createFileRoute('/_authenticated/')()
const AuthenticatedPrivacy_policyLazyRouteImport = createFileRoute(
  '/_authenticated/privacy_policy',
)()
const AccountForgotPasswordLazyRouteImport = createFileRoute(
  '/account/forgot-password',
)()
const AccountResetPasswordLazyRouteImport = createFileRoute(
  '/account/reset-password',
)()
const CountdownIndexLazyRouteImport = createFileRoute('/countdown/')()
const AuthenticatedMeIndexLazyRouteImport = createFileRoute(
  '/_authenticated/me/',
)()
const AuthenticatedRegisterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/register/',
)()
const PaymentCallbackIndexLazyRouteImport =
  createFileRoute('/payment/callback/')()
const PaymentCallbackFailLazyRouteImport = createFileRoute(
  '/payment/callback/fail',
)()
const PaymentCallbackSuccessLazyRouteImport = createFileRoute(
  '/payment/callback/success',
)()
const AuthenticatedRegisterAsanIndexLazyRouteImport = createFileRoute(
  '/_authenticated/register/asan/',
)()
const AuthenticatedRegisterAsanSuccessLazyRouteImport = createFileRoute(
  '/_authenticated/register/asan/success',
)()
const AuthenticatedRegisterEditReservationCodeLazyRouteImport = createFileRoute(
  '/_authenticated/register/edit/$reservationCode',
)()
const AuthenticatedMeApplicationEditReservationCodeLazyRouteImport =
  createFileRoute('/_authenticated/me/application/edit/$reservationCode')()

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninLazyRoute = SigninLazyRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/signin.lazy').then((d) => d.Route))
const AuthenticatedIndexLazyRoute = AuthenticatedIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/index.lazy').then((d) => d.Route),
)
const AuthenticatedPrivacy_policyLazyRoute =
  AuthenticatedPrivacy_policyLazyRouteImport.update({
    id: '/privacy_policy',
    path: '/privacy_policy',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/privacy_policy.lazy').then((d) => d.Route),
  )
const AccountForgotPasswordLazyRoute =
  AccountForgotPasswordLazyRouteImport.update({
    id: '/account/forgot-password',
    path: '/account/forgot-password',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/account/forgot-password.lazy').then((d) => d.Route),
  )
const AccountResetPasswordLazyRoute =
  AccountResetPasswordLazyRouteImport.update({
    id: '/account/reset-password',
    path: '/account/reset-password',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/account/reset-password.lazy').then((d) => d.Route),
  )
const CountdownIndexLazyRoute = CountdownIndexLazyRouteImport.update({
  id: '/countdown/',
  path: '/countdown/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/countdown/index.lazy').then((d) => d.Route),
)
const AuthenticatedMeIndexLazyRoute =
  AuthenticatedMeIndexLazyRouteImport.update({
    id: '/me/',
    path: '/me/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/me/index.lazy').then((d) => d.Route),
  )
const AuthenticatedRegisterIndexLazyRoute =
  AuthenticatedRegisterIndexLazyRouteImport.update({
    id: '/register/',
    path: '/register/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/register/index.lazy').then((d) => d.Route),
  )
const PaymentCallbackIndexLazyRoute =
  PaymentCallbackIndexLazyRouteImport.update({
    id: '/payment/callback/',
    path: '/payment/callback/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/payment/callback/index.lazy').then((d) => d.Route),
  )
const PaymentCallbackFailLazyRoute = PaymentCallbackFailLazyRouteImport.update({
  id: '/payment/callback/fail',
  path: '/payment/callback/fail',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/payment/callback/fail.lazy').then((d) => d.Route),
)
const PaymentCallbackSuccessLazyRoute =
  PaymentCallbackSuccessLazyRouteImport.update({
    id: '/payment/callback/success',
    path: '/payment/callback/success',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/payment/callback/success.lazy').then((d) => d.Route),
  )
const AuthenticatedRegisterAsanIndexLazyRoute =
  AuthenticatedRegisterAsanIndexLazyRouteImport.update({
    id: '/register/asan/',
    path: '/register/asan/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/register/asan/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedRegisterAsanSuccessLazyRoute =
  AuthenticatedRegisterAsanSuccessLazyRouteImport.update({
    id: '/register/asan/success',
    path: '/register/asan/success',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/register/asan/success.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedRegisterEditReservationCodeLazyRoute =
  AuthenticatedRegisterEditReservationCodeLazyRouteImport.update({
    id: '/register/edit/$reservationCode',
    path: '/register/edit/$reservationCode',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/register/edit/$reservationCode.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMeApplicationEditReservationCodeLazyRoute =
  AuthenticatedMeApplicationEditReservationCodeLazyRouteImport.update({
    id: '/me/application/edit/$reservationCode',
    path: '/me/application/edit/$reservationCode',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/me/application/edit/$reservationCode.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexLazyRoute
  '/signin': typeof SigninLazyRoute
  '/privacy_policy': typeof AuthenticatedPrivacy_policyLazyRoute
  '/account/forgot-password': typeof AccountForgotPasswordLazyRoute
  '/account/reset-password': typeof AccountResetPasswordLazyRoute
  '/countdown/': typeof CountdownIndexLazyRoute
  '/payment/callback/fail': typeof PaymentCallbackFailLazyRoute
  '/payment/callback/success': typeof PaymentCallbackSuccessLazyRoute
  '/me/': typeof AuthenticatedMeIndexLazyRoute
  '/register/': typeof AuthenticatedRegisterIndexLazyRoute
  '/payment/callback/': typeof PaymentCallbackIndexLazyRoute
  '/register/asan/success': typeof AuthenticatedRegisterAsanSuccessLazyRoute
  '/register/edit/$reservationCode': typeof AuthenticatedRegisterEditReservationCodeLazyRoute
  '/register/asan/': typeof AuthenticatedRegisterAsanIndexLazyRoute
  '/me/application/edit/$reservationCode': typeof AuthenticatedMeApplicationEditReservationCodeLazyRoute
}
export interface FileRoutesByTo {
  '/signin': typeof SigninLazyRoute
  '/privacy_policy': typeof AuthenticatedPrivacy_policyLazyRoute
  '/account/forgot-password': typeof AccountForgotPasswordLazyRoute
  '/account/reset-password': typeof AccountResetPasswordLazyRoute
  '/': typeof AuthenticatedIndexLazyRoute
  '/countdown': typeof CountdownIndexLazyRoute
  '/payment/callback/fail': typeof PaymentCallbackFailLazyRoute
  '/payment/callback/success': typeof PaymentCallbackSuccessLazyRoute
  '/me': typeof AuthenticatedMeIndexLazyRoute
  '/register': typeof AuthenticatedRegisterIndexLazyRoute
  '/payment/callback': typeof PaymentCallbackIndexLazyRoute
  '/register/asan/success': typeof AuthenticatedRegisterAsanSuccessLazyRoute
  '/register/edit/$reservationCode': typeof AuthenticatedRegisterEditReservationCodeLazyRoute
  '/register/asan': typeof AuthenticatedRegisterAsanIndexLazyRoute
  '/me/application/edit/$reservationCode': typeof AuthenticatedMeApplicationEditReservationCodeLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/signin': typeof SigninLazyRoute
  '/_authenticated/privacy_policy': typeof AuthenticatedPrivacy_policyLazyRoute
  '/account/forgot-password': typeof AccountForgotPasswordLazyRoute
  '/account/reset-password': typeof AccountResetPasswordLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexLazyRoute
  '/countdown/': typeof CountdownIndexLazyRoute
  '/payment/callback/fail': typeof PaymentCallbackFailLazyRoute
  '/payment/callback/success': typeof PaymentCallbackSuccessLazyRoute
  '/_authenticated/me/': typeof AuthenticatedMeIndexLazyRoute
  '/_authenticated/register/': typeof AuthenticatedRegisterIndexLazyRoute
  '/payment/callback/': typeof PaymentCallbackIndexLazyRoute
  '/_authenticated/register/asan/success': typeof AuthenticatedRegisterAsanSuccessLazyRoute
  '/_authenticated/register/edit/$reservationCode': typeof AuthenticatedRegisterEditReservationCodeLazyRoute
  '/_authenticated/register/asan/': typeof AuthenticatedRegisterAsanIndexLazyRoute
  '/_authenticated/me/application/edit/$reservationCode': typeof AuthenticatedMeApplicationEditReservationCodeLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/privacy_policy'
    | '/account/forgot-password'
    | '/account/reset-password'
    | '/countdown/'
    | '/payment/callback/fail'
    | '/payment/callback/success'
    | '/me/'
    | '/register/'
    | '/payment/callback/'
    | '/register/asan/success'
    | '/register/edit/$reservationCode'
    | '/register/asan/'
    | '/me/application/edit/$reservationCode'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signin'
    | '/privacy_policy'
    | '/account/forgot-password'
    | '/account/reset-password'
    | '/'
    | '/countdown'
    | '/payment/callback/fail'
    | '/payment/callback/success'
    | '/me'
    | '/register'
    | '/payment/callback'
    | '/register/asan/success'
    | '/register/edit/$reservationCode'
    | '/register/asan'
    | '/me/application/edit/$reservationCode'
  id:
    | '__root__'
    | '/_authenticated'
    | '/signin'
    | '/_authenticated/privacy_policy'
    | '/account/forgot-password'
    | '/account/reset-password'
    | '/_authenticated/'
    | '/countdown/'
    | '/payment/callback/fail'
    | '/payment/callback/success'
    | '/_authenticated/me/'
    | '/_authenticated/register/'
    | '/payment/callback/'
    | '/_authenticated/register/asan/success'
    | '/_authenticated/register/edit/$reservationCode'
    | '/_authenticated/register/asan/'
    | '/_authenticated/me/application/edit/$reservationCode'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SigninLazyRoute: typeof SigninLazyRoute
  AccountForgotPasswordLazyRoute: typeof AccountForgotPasswordLazyRoute
  AccountResetPasswordLazyRoute: typeof AccountResetPasswordLazyRoute
  CountdownIndexLazyRoute: typeof CountdownIndexLazyRoute
  PaymentCallbackFailLazyRoute: typeof PaymentCallbackFailLazyRoute
  PaymentCallbackSuccessLazyRoute: typeof PaymentCallbackSuccessLazyRoute
  PaymentCallbackIndexLazyRoute: typeof PaymentCallbackIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/privacy_policy': {
      id: '/_authenticated/privacy_policy'
      path: '/privacy_policy'
      fullPath: '/privacy_policy'
      preLoaderRoute: typeof AuthenticatedPrivacy_policyLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/account/forgot-password': {
      id: '/account/forgot-password'
      path: '/account/forgot-password'
      fullPath: '/account/forgot-password'
      preLoaderRoute: typeof AccountForgotPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/reset-password': {
      id: '/account/reset-password'
      path: '/account/reset-password'
      fullPath: '/account/reset-password'
      preLoaderRoute: typeof AccountResetPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/countdown/': {
      id: '/countdown/'
      path: '/countdown'
      fullPath: '/countdown/'
      preLoaderRoute: typeof CountdownIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/me/': {
      id: '/_authenticated/me/'
      path: '/me'
      fullPath: '/me/'
      preLoaderRoute: typeof AuthenticatedMeIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/register/': {
      id: '/_authenticated/register/'
      path: '/register'
      fullPath: '/register/'
      preLoaderRoute: typeof AuthenticatedRegisterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/payment/callback/': {
      id: '/payment/callback/'
      path: '/payment/callback'
      fullPath: '/payment/callback/'
      preLoaderRoute: typeof PaymentCallbackIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/callback/fail': {
      id: '/payment/callback/fail'
      path: '/payment/callback/fail'
      fullPath: '/payment/callback/fail'
      preLoaderRoute: typeof PaymentCallbackFailLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment/callback/success': {
      id: '/payment/callback/success'
      path: '/payment/callback/success'
      fullPath: '/payment/callback/success'
      preLoaderRoute: typeof PaymentCallbackSuccessLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/register/asan/': {
      id: '/_authenticated/register/asan/'
      path: '/register/asan'
      fullPath: '/register/asan/'
      preLoaderRoute: typeof AuthenticatedRegisterAsanIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/register/asan/success': {
      id: '/_authenticated/register/asan/success'
      path: '/register/asan/success'
      fullPath: '/register/asan/success'
      preLoaderRoute: typeof AuthenticatedRegisterAsanSuccessLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/register/edit/$reservationCode': {
      id: '/_authenticated/register/edit/$reservationCode'
      path: '/register/edit/$reservationCode'
      fullPath: '/register/edit/$reservationCode'
      preLoaderRoute: typeof AuthenticatedRegisterEditReservationCodeLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/me/application/edit/$reservationCode': {
      id: '/_authenticated/me/application/edit/$reservationCode'
      path: '/me/application/edit/$reservationCode'
      fullPath: '/me/application/edit/$reservationCode'
      preLoaderRoute: typeof AuthenticatedMeApplicationEditReservationCodeLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedPrivacy_policyLazyRoute: typeof AuthenticatedPrivacy_policyLazyRoute
  AuthenticatedIndexLazyRoute: typeof AuthenticatedIndexLazyRoute
  AuthenticatedMeIndexLazyRoute: typeof AuthenticatedMeIndexLazyRoute
  AuthenticatedRegisterIndexLazyRoute: typeof AuthenticatedRegisterIndexLazyRoute
  AuthenticatedRegisterAsanSuccessLazyRoute: typeof AuthenticatedRegisterAsanSuccessLazyRoute
  AuthenticatedRegisterEditReservationCodeLazyRoute: typeof AuthenticatedRegisterEditReservationCodeLazyRoute
  AuthenticatedRegisterAsanIndexLazyRoute: typeof AuthenticatedRegisterAsanIndexLazyRoute
  AuthenticatedMeApplicationEditReservationCodeLazyRoute: typeof AuthenticatedMeApplicationEditReservationCodeLazyRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedPrivacy_policyLazyRoute: AuthenticatedPrivacy_policyLazyRoute,
  AuthenticatedIndexLazyRoute: AuthenticatedIndexLazyRoute,
  AuthenticatedMeIndexLazyRoute: AuthenticatedMeIndexLazyRoute,
  AuthenticatedRegisterIndexLazyRoute: AuthenticatedRegisterIndexLazyRoute,
  AuthenticatedRegisterAsanSuccessLazyRoute:
    AuthenticatedRegisterAsanSuccessLazyRoute,
  AuthenticatedRegisterEditReservationCodeLazyRoute:
    AuthenticatedRegisterEditReservationCodeLazyRoute,
  AuthenticatedRegisterAsanIndexLazyRoute:
    AuthenticatedRegisterAsanIndexLazyRoute,
  AuthenticatedMeApplicationEditReservationCodeLazyRoute:
    AuthenticatedMeApplicationEditReservationCodeLazyRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SigninLazyRoute: SigninLazyRoute,
  AccountForgotPasswordLazyRoute: AccountForgotPasswordLazyRoute,
  AccountResetPasswordLazyRoute: AccountResetPasswordLazyRoute,
  CountdownIndexLazyRoute: CountdownIndexLazyRoute,
  PaymentCallbackFailLazyRoute: PaymentCallbackFailLazyRoute,
  PaymentCallbackSuccessLazyRoute: PaymentCallbackSuccessLazyRoute,
  PaymentCallbackIndexLazyRoute: PaymentCallbackIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
